const txeLibInit = {

    entries:[],
    units:[],
    btnClick:"",
    editTx:"",
}
export default txeLibInit;
